import React, { useEffect, useState } from "react";
import axios from "axios";
import Loader from "../components/Loader";
import Title from "../components/Title";
import { useDispatch, useSelector } from "react-redux";
import { getToken } from "../slice/tokenSlice";
import { FaFilter, FaLink, FaTimes } from "react-icons/fa";

const Payment = () => {
  const dispatch = useDispatch();
  const { url, user } = useSelector((state) => state.user);
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const [loading, setLoading] = useState(false);
  const getProforma = async () => {
    try {
      const token = await dispatch(getToken());
      setLoading(true);
      const res = await axios.get(
        `${url}/proxy?url=https://www.zohoapis.in/crm/v2/Leads/${user.id}/Proforma_Invoice`,
        {
          headers: {
            Authorization: `Zoho-oauthtoken ${token.payload}`,
          },
        },
      );
      if (res.status === 200) {
        const response = res.data.data;
        response.forEach((item) => {
          Object.keys(item).forEach((key) => {
            item[key] = item[key] ?? "";
            if (key === "Status") {
              if (item[key] === "") {
                item.pillStatus = "";
              } else if (item[key].toLowerCase() === "paid") {
                item.pillStatus = "paid-pill";
              } else if (item[key].toLowerCase() === "pending") {
                item.pillStatus = "pending-pill";
              } else if (item[key].toLowerCase() === "draft") {
                item.pillStatus = "draft-pill";
              } else if (item[key].toLowerCase() === "sent") {
                item.pillStatus = "sent-pill";
              } else if (item[key].toLowerCase() === "overdue") {
                item.pillStatus = "overdue-pill";
              } else if (item[key].toLowerCase() === "void") {
                item.pillStatus = "void-pill";
              } else if (item[key].toLowerCase() === "partially paid") {
                item.pillStatus = "partially-paid-pill";
              }
            }
          });
        });
        //
        setData1(response);
        setData2(response);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (user !== null) {
      getProforma();
    }
  }, [user]);
  //
  const [searchInput, setSearchInput] = useState("");
  const [filterInputs, setFilterInputs] = useState({
    status: "",
    paidDate: "",
  });
  const handleFilterInputs = (e) => {
    const { name, value } = e.target;
    setFilterInputs({
      ...filterInputs,
      [name]: value,
    });
  };
  const filterData = () => {
    const filtered = data1.filter((item) => {
      const name = item?.Name?.toLowerCase().includes(
        searchInput.toLowerCase(),
      );

      const paidDateMatch =
        filterInputs.paidDate === "" ||
        item?.Payment_Date?.toLowerCase() === filterInputs.paidDate;

      const statusMatch =
        filterInputs.status === "" ||
        item?.Status?.toLowerCase() === filterInputs.status;

      return name && statusMatch && paidDateMatch;
    });
    setData2(filtered);
    setModalVisible(false);
  };
  useEffect(() => {
    filterData();
  }, [searchInput, data1]);
  //
  const [modalVisible, setModalVisible] = useState(false);
  const openModal = () => {
    setModalVisible(true);
  };
  const closeModal = () => {
    setModalVisible(false);
  };
  const resetSearchFilter = () => {
    setSearchInput("");
    setFilterInputs({
      status: "",
      paidDate: "",
    });
    setModalVisible(false);
    setData2(data1);
  };
  return (
    <>
      <div className="payments-container">
        <div className="d-flex justify-content-between gap-2 flex-sm-row flex-column">
          <Title title="Payments" />
          <div className="filter-flex">
            <input
              type="text"
              className="input"
              placeholder="Search..."
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />
            <button className="button" onClick={openModal}>
              <FaFilter />
            </button>
          </div>
        </div>
        <hr />
        <div className="project-table-overflow">
          {loading === true ? (
            <Loader />
          ) : (
            <>
              {data2.length === 0 ? (
                <p className="text-center">No data found</p>
              ) : (
                <table className="project-table payments-table">
                  <thead>
                    <tr>
                      <th>Sr</th>
                      <th>Invoice Number</th>
                      <th>Amount</th>
                      <th>Status</th>
                      <th>Payment Mode</th>
                      <th>Payment Date</th>
                      <th>Payment Link</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data2.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.Name || "-"}</td>
                          <td>
                            {item.Invoice_Amount
                              ? "₹" + item.Invoice_Amount
                              : "-"}
                          </td>
                          <td>
                            <span className={`pill ${item.pillStatus}`}>
                              {item.Status
                                ? item.Status.charAt(0).toUpperCase() +
                                  item.Status.slice(1).toLowerCase()
                                : "-"}
                            </span>
                          </td>
                          <td>{item.Payment_Mode || "-"}</td>
                          <td>
                            {item.Payment_Date?.split("-")
                              .reverse()
                              .join("-") || "-"}
                          </td>
                          <td>
                            <a
                              href={item.Payment_Link}
                              target="_blank"
                              className="button d-block px-4"
                              style={{ width: "fit-content" }}
                            >
                              <FaLink />
                            </a>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </>
          )}
        </div>
      </div>

      <div
        className={`modal-background ${modalVisible ? "active" : ""}`}
        style={{ zIndex: "100" }}
      >
        <div className="modal-container">
          <div className="d-flex align-items-end justify-content-between">
            <h2>Filter</h2>
            <button className="red-button" onClick={closeModal}>
              <FaTimes />
            </button>
          </div>
          {/*  */}
          <hr />
          <div>
            <div className="mt-4">
              <p className="mb-2">Status</p>
              <select
                className="input"
                name="status"
                value={filterInputs.status}
                onChange={handleFilterInputs}
              >
                <option value="">Select</option>
                <option value="paid">Paid</option>
                <option value="sent">Sent</option>
                <option value="unpaid">unpaid</option>
              </select>
            </div>
            <div className="mt-4">
              <p className="mb-2">Payment date</p>
              <input
                type="date"
                className="input"
                name="paidDate"
                value={filterInputs.paidDate}
                onChange={handleFilterInputs}
              />
            </div>
          </div>
          <div className="d-flex align-content-center justify-content-end gap-2 mt-4">
            <button
              className="red-button"
              onClick={resetSearchFilter}
              style={{ width: "90px" }}
            >
              Reset
            </button>
            <button
              className="button"
              onClick={filterData}
              style={{ width: "90px" }}
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Payment;
